import { motion } from "framer-motion";
import { FaArrowUp, FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const navLinks = [
    { name: "Home", href: "#Home" },
    { name: "About", href: "#About" },
    { name: "Projects", href: "/projects" },
    { name: "Contact", href: "#Contact" },
  ];

  const socialLinks = [
    { icon: FaGithub, href: "https://github.com/Avansh2006", label: "GitHub" },
    { icon: FaLinkedin, href: "https://linkedin.com/in/avanshyadav", label: "LinkedIn" },
    { icon: FaTwitter, href: "https://twitter.com/Avansh2006", label: "Twitter" },
  ];

  return (
    <footer className="relative mt-10 px-3 pb-5 text-white sm:px-6 lg:px-8 2xl:px-12">
      <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#050316] to-transparent pointer-events-none sm:h-36" />

      <div className="relative mx-auto max-w-7xl 2xl:max-w-[88rem]">
        <div className="overflow-hidden rounded-2xl border border-white/10 bg-[#0b0820]/90 shadow-2xl shadow-purple-950/20 backdrop-blur-xl">
          <div className="flex flex-col gap-4 px-4 py-4 sm:px-5 md:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-6 xl:px-8">
            <div className="flex min-w-0 flex-col items-center text-center lg:items-start lg:text-left">
              <p className="text-sm font-semibold tracking-wide sm:text-base">Avansh Yadav</p>
              <p className="mt-0.5 text-[11px] text-gray-500 sm:text-xs">
                © {currentYear} Portfolio
              </p>
            </div>

            <nav className="grid w-full grid-cols-2 gap-2 rounded-xl border border-white/10 bg-white/[0.03] p-1.5 min-[420px]:grid-cols-4 sm:flex sm:w-auto sm:flex-wrap sm:items-center sm:justify-center sm:gap-1 sm:rounded-full lg:flex-nowrap">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="rounded-lg px-3 py-2 text-center text-xs font-medium text-gray-400 transition-colors duration-200 hover:bg-white/10 hover:text-white sm:rounded-full sm:py-1.5 sm:text-sm xl:px-4"
                  aria-label={`Navigate to ${link.name}`}
                >
                  {link.name}
                </a>
              ))}
            </nav>

            <div className="flex w-full items-center justify-center gap-2 sm:w-auto lg:justify-end">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.94 }}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-gray-400 transition-colors duration-200 hover:border-purple-400/50 hover:text-white sm:h-10 sm:w-10"
                    aria-label={social.label}
                  >
                    <Icon size={15} />
                  </motion.a>
                );
              })}

              <motion.button
                type="button"
                onClick={scrollToTop}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.94 }}
                className="ml-1 flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg shadow-purple-600/20 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:ring-offset-[#0b0820] sm:h-10 sm:w-10"
                aria-label="Scroll to top"
              >
                <FaArrowUp size={13} />
              </motion.button>
            </div>
          </div>

          <div className="flex flex-col items-center justify-between gap-2 border-t border-white/10 px-4 py-3 text-[11px] text-gray-500 sm:flex-row sm:px-5 md:px-6 xl:px-8">
            <span className="text-center sm:text-left">
              Built with React, Three.js and clean code.
            </span>
            <span className="text-center sm:text-right">
              Available for collaboration.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
